import $ from 'jquery';

jQuery(document).ready(function ($) {
  // When the form is submitted
  $('.wpcf7-form').on('submit', function () {
    if ($(this).closest('#modal-md').length) {
      // Hide the form fields and show the loading icon
      $(
        '#modal-md .wpcf7-form-control, #modal-md p, #modal-md .wpcf7-submit'
      ).hide();
      $('#modal-md .loading-icon').removeClass('hide');
    }
  });

  // When the form successfully submits
  document.addEventListener(
    'wpcf7mailsent',
    function (event) {
      if ($(event.target).closest('#modal-md').length) {
        // Hide the loading icon
        $('#modal-md .loading-icon').addClass('hide');

        // Show the close button
        $('#modal-md button.bottom-close').removeClass('hide');
      }
    },
    false
  );
});
